<template>
  <div>
    <div class="downloads">
      <div class="downloads__item" :class="{'downloads__item--loading': general_loading}">
        <div class="downloads__left">
          <img :src="require('@/assets/img/downloads-xls.svg')" alt="Download">
          <div class="downloads__info">
            <button @click="onDownloadGeneral" class="downloads__name">General</button>
          </div>
        </div>
      </div>
      <div class="downloads__item" :class="{'downloads__item--loading': paye_loading}">
        <div class="downloads__left">
          <img :src="require('@/assets/img/downloads-xls.svg')" alt="Download">
          <div class="downloads__info">
            <button @click="onDownloadPAYE" class="downloads__name">PAYE</button>
          </div>
        </div>
      </div>
      <div class="downloads__item" :class="{'downloads__item--loading': nssf_loading}">
        <div class="downloads__left">
          <img :src="require('@/assets/img/downloads-xls.svg')" alt="Download">
          <div class="downloads__info">
            <button @click="onDownloadNSSF" class="downloads__name">NSSF</button>
          </div>
        </div>
      </div>
      <div class="downloads__item" :class="{'downloads__item--loading': nhif_loading}">
        <div class="downloads__left">
          <img :src="require('@/assets/img/downloads-xls.svg')" alt="Download">
          <div class="downloads__info">
            <button @click="onDownloadNHIF" class="downloads__name">NHIF</button>
          </div>
        </div>
      </div>
      <div class="downloads__item" :class="{'downloads__item--loading': nmb_loading}">
        <div class="downloads__left">
          <img :src="require('@/assets/img/downloads-xls.svg')" alt="Download">
          <div class="downloads__info">
            <button @click="onDownloadNMB" class="downloads__name">NMB</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEmployeesExportPAYE,
  getEmployeesExportNSSF,
  getEmployeesExportNHIF,
  getEmployeesExportNMB,
  getEmployeesExportGeneral
} from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'EmployeesPayrollDownloads',
  props: {
    payroll: Object,
  },
  data() {
    return {
      general_loading: false,
      paye_loading: false,
      nssf_loading: false,
      nhif_loading: false,
      nmb_loading: false,
    }
  },
  methods: {
    onDownloadGeneral() {
      this.general_loading = true
      getEmployeesExportGeneral(this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.payroll.month)} General - ${this.payroll.legal_entity.name}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.general_loading = false
        })
    },
    onDownloadPAYE() {
      this.paye_loading = true
      getEmployeesExportPAYE(this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.payroll.month)} PAYE - ${this.payroll.legal_entity.name}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.paye_loading = false
        })
    },
    onDownloadNSSF() {
      this.nssf_loading = true
      getEmployeesExportNSSF(this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.payroll.month)} NSSF - ${this.payroll.legal_entity.name}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.nssf_loading = false
        })

    },
    onDownloadNHIF() {
      this.nhif_loading = true
      getEmployeesExportNHIF(this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.payroll.month)} NHIF - ${this.payroll.legal_entity.name}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.nhif_loading = false
        })

    },
    onDownloadNMB() {
      this.nmb_loading = true
      getEmployeesExportNMB(this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.payroll.month)} NMB - ${this.payroll.legal_entity.name}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.nmb_loading = false
        })

    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
    },
  }
}
</script>
